import { 
	CallOutbound,
} from 'src/app/database-models';

export class CallOutboundLookupGroup {
	callOutbound : CallOutbound;
}
